<template>
  <CommonLayout header="customerHeader" footer="customerFooter">
    <CustomerMeetingLayout :type="this.consts.meetingType.customer" @changeIsOperationPossible="changeIsOperationPossible">
      <BOverlay :show="overlayShow" rounded="sm">
        <div class="base-color overflow-auto mh-550 shadow">
          <form method="post" action="#" class="form-horizontal">
            <div class="col-sm-12 p-5 mt-3">
              <span class="text-break" v-if="mailAddressInMsg && !brideMailAddressInMsg" >ご入力いただいたメールアドレス（<span id="mailAddressInMsg">{{mailAddressInMsg}}</span>）にメールを
              送信いたしました。メールが届いているかご確認をお願いいたします。
              メールアドレスを変更する場合は以下のボタンからメールアドレスの変更をお願いいたします。</span>
              <span class="text-break" v-else-if="!mailAddressInMsg && brideMailAddressInMsg" >ご入力いただいたメールアドレス（<span id="brideMailAddressInMsg">{{brideMailAddressInMsg}}</span>）にメールを
              送信いたしました。メールが届いているかご確認をお願いいたします。
              メールアドレスを変更する場合は以下のボタンからメールアドレスの変更をお願いいたします。</span>
              <span class="text-break" v-else-if="mailAddressInMsg && brideMailAddressInMsg" >ご入力いただいたメールアドレス（<span id="mailAddressInMsg">{{mailAddressInMsg}}</span>, <span id="brideMailAddressInMsg">{{brideMailAddressInMsg}}</span>）にメールを
              送信いたしました。メールが届いているかご確認をお願いいたします。
              メールアドレスを変更する場合は以下のボタンからメールアドレスの変更をお願いいたします。</span>
            </div>
            <div class="col-sm-12">
              <div class="w-75 mt-5-auto">
                <BButton block variant="outline-secondary" class="w-100 sub-button-color white-btn-disabled" @click="showMailForm" :disabled="!isOperationPossible">メールアドレスを変更する場合</BButton>
              </div>
            </div>
            <transition name="fade">
              <div class="mail-send-form col-sm-12" v-show="isShowMailForm">
                <label for="mailAddress" class="control-label col-sm-12 mb-0">メールアドレス(1){{shinroShinpu1 !== 'shinro' ? '(ご新婦様)' : '(ご新郎様)'}}</label>
                <div class="input-group">
                  <input type="text" id="mailAddress" class="form-control input-sm send-mail-input" :class="{'is-invalid is-invalid-custom' : v$.mailAddress.$error}" v-model="mailAddress" @blur="onBlur('mailAddress', $event)" :disabled="!isOperationPossible"/>
                  <div class="invalid-feedback" v-for="e of v$.mailAddress.$errors" :key="e.$uid">{{ e.$message }}</div>
                </div>
                <label for="brideMailAddress" class="control-label col-sm-12 mb-0 mt-2">メールアドレス(2){{shinroShinpu2 !== 'shinpu' ? '(ご新郎様)' : '(ご新婦様)'}}</label>
                <div class="input-group">
                  <input type="text" id="brideMailAddress" class="form-control input-sm send-mail-input" :class="{'is-invalid is-invalid-custom' : v$.brideMailAddress.$error }" v-model="brideMailAddress" @blur="onBlur('brideMailAddress', $event)" :disabled="!isOperationPossible"/>
                  <div class="invalid-feedback" v-for="e of v$.brideMailAddress.$errors" :key="e.$uid">{{ e.$message }}</div>
                </div>
                <div class="input-group-btn text-end">
                  <BButton variant="outline-secondary" class="subbutton-color ps-4 pe-4 white-btn-disabled mt-3" @click="sendMail" :disabled="!isOperationPossible">送信</BButton>
                </div>
              </div>
            </transition>
          </form>
        </div>
      </BOverlay>
    </CustomerMeetingLayout>
    <CommonModal ref="commonModal" />
  </CommonLayout>
</template>
<style scoped type="text/css">
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s
}
.fade-enter-from, .fade-leave-to {
  opacity: 0
}
</style>
<script>
import { createApp } from 'vue'
import CommonLayout from '@/layout/CommonLayout'
import CommonModal from '@/components/CommonModal'
import CustomerMeetingLayout from '@/layout/CustomerMeetingLayout'
// import SimpleVueValidation from 'simple-vue-validator'
import CustomerUpdateModel from '@/models/CustomerUpdateModel'
import cstore from '@/store/customer-store'
import mstore from '@/store/meeting-store'
import SignalingModel from '@/models/SignalingModel'
import CommonLogModel from '@/models/CommonLogModel'
import useVuelidate from '@vuelidate/core'
import { email, helpers } from '@vuelidate/validators'
// const Validator = SimpleVueValidation.Validator
// const app = createApp({})

// app.use(SimpleVueValidation)

export default {
  name: 'CustomerMeetingSendMail',
  components: { CommonLayout, CommonModal, CustomerMeetingLayout },
  setup () {
    return { v$: useVuelidate() }
  },
  data () {
    return {
      isShowMailForm: false,
      overlayShow: false,
      mailAddressInMsg: '',
      brideMailAddressInMsg: '',
      mailAddress: '',
      brideMailAddress: '',
      isSendFirstSignalingData: false,
      isOperationPossible: false,
      customerDisplayFlag: cstore.getters.customerDisplayFlag === null ? false : cstore.getters.customerDisplayFlag,
      shinroShinpu1: '',
      shinroShinpu2: ''
    }
  },
  computed: {
    getIsTargetAtendeeActive () {
      // フローリストとの疎通確立フラグ取得
      return mstore.getters.isTargetAtendeeActive
    },
    getSignalingData () {
      return cstore.getters.signalingReceiveData
    }
  },
  watch: {
    getIsTargetAtendeeActive: function (newData, oldData) {
      if (!this.isSendFirstSignalingData && mstore.getters.isTargetAtendeeActive) {
        this.sendSignalingInputData()
        this.isSendFirstSignalingData = true
      }
    },
    getSignalingData (newData, oldData) {
      try {
        newData['user'] = 'customer'
        newData['timestampMs'] = Date.now()
        CommonLogModel.apiSetStore(this.$refs.commonModal, newData, () => {
        })
        if (newData['current_path'] && oldData) {
          const synchPass = newData['current_path'].replace('florist', 'customer')
          if (synchPass !== this.$route.path) {
            return this.$router.push(synchPass)
          }
        }

        if (!cstore.getters.isOperationPossible) {
          if (newData['event'] === 'click' && newData['id'] === 'sendMail') {
            this.signalSendMail()
          }

          if (newData['event'] === 'click') {
            if (newData['id'] === 'next' || newData['id'] === 'back') {
              this.$router.push(newData['target_path'])
            }
          }
          if (newData['event'] === 'input' && !this.isOperationPossible) {
            for (let i = 0; i < newData['data'].length; i++) {
              if (newData['data'][i] && newData['data'][i].id) {
                let elm = document.getElementById(newData['data'][i].id)
                if (newData['data'][i].id === 'isShowMailForm') {
                  this.isShowMailForm = newData['data'][i].value
                } else if (newData['data'][i].target) {
                  elm.value = newData['data'][i].value
                  elm.dispatchEvent(new Event('input'))
                  if (newData.data[i].id === 'mailAddress') this.v$.mailAddress.$touch()
                  if (newData.data[i].id === 'brideMailAddress') this.v$.brideMailAddress.$touch()
                  elm.dispatchEvent(new Event('change'))
                } else {
                  elm.value = newData['data'][i].value
                  elm.dispatchEvent(new Event('input'))
                  if (newData.data[i].id === 'mailAddress') this.v$.mailAddress.$touch()
                  if (newData.data[i].id === 'brideMailAddress') this.v$.brideMailAddress.$touch()
                  elm.dispatchEvent(new Event('change'))
                }
              }
            }
          }
        }
        if (newData['event'] === 'click') {
          if (sessionStorage.customerType !== this.consts.customerType.guest) {
            if (newData['id'] === 'operationInvalid') {
              cstore.commit('setIsOperationPossible', false)
              this.isOperationPossible = false
            } else if (newData['id'] === 'operationPossible') {
              cstore.commit('setIsOperationPossible', true)
              this.isOperationPossible = true
            }
          }
          if (newData['id'] === 'priceHide') {
            cstore.commit('setCustomerDisplayFlag', false)
            this.customerDisplayFlag = cstore.getters.customerDisplayFlag
          } else if (newData['id'] === 'priceDisplay') {
            cstore.commit('setCustomerDisplayFlag', true)
            this.customerDisplayFlag = cstore.getters.customerDisplayFlag
          }
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$refs.commonModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    }
  },
  validations () {
    const msg = this.consts?.validationMsg?.meetingInput || {}
    const halfWidth = helpers.regex(/^[" -~]*$/)

    return {
      mailAddress: {
        email: helpers.withMessage(msg?.mailAddress?.email || '有効なメールアドレスを入力してください', email),
        halfWidth: helpers.withMessage(msg?.mailAddress?.halfWidth || '半角で入力してください', halfWidth)
      },
      brideMailAddress: {
        email: helpers.withMessage(msg?.brideMailAddress?.email || '有効なメールアドレスを入力してください', email),
        halfWidth: helpers.withMessage(msg?.brideMailAddress?.halfWidth || '半角で入力してください', halfWidth)
      }
    }
  },
  methods: {
    showMailForm () {
      try {
        this.isShowMailForm = !this.isShowMailForm
        this.sendSignalingInputData()
      } catch (err) {
        CommonLogModel.apiSetStore(this.$refs.commonModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    onBlur (key, e) {
      this.v$?.[key]?.$touch?.()
      this.sendSignalingInputData(e)
    },
    sendSignalingInputData (e) {
      try {
        const inputs = document.querySelectorAll('.send-mail-input')
        let sendData = []

        for (let i = 0; i < inputs.length; i++) {
          if (typeof e !== 'undefined' && inputs[i].id === e.target.id) {
            sendData[i] = { target: e.target.id, id: inputs[i].id, value: inputs[i].value }
          } else {
            sendData[i] = { id: inputs[i].id, value: inputs[i].value }
          }
        }

        sendData.push({ id: 'isShowMailForm', value: this.isShowMailForm })
        sendData = sendData.filter(d => d.id) // 念のため

        SignalingModel.sendInputEvent(this, sendData)
      } catch (err) {
        CommonLogModel.apiSetStore(this.$refs.commonModal, { timestampMs: Date.now(), error: err }, () => {})
      }
    },
    sendMail: async function () {
      try {
        if (this.isOperationPossible) {
          const isValid = await this.v$.$validate()

          SignalingModel.sendClickEvent('sendMail', this)

          if (!isValid) return false
          // 空白文字のみの入力の可能性がある為、メールアドレスの空白文字を削除する
          this.mailAddress = this.mailAddress.trim()
          this.brideMailAddress = this.brideMailAddress.trim()

          this.overlayShow = true
          const params = {
            'mailAddress': this.mailAddress,
            'brideMailAddress': this.brideMailAddress
          }
          await CustomerUpdateModel.apiSetStore(this.$refs.commonModal, params, () => {
            this.overlayShow = false
          })
          this.mailAddressInMsg = this.mailAddress
          this.brideMailAddressInMsg = this.brideMailAddress
          this.$refs.commonModal.msgBoxOk('メールを送信しました')
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$refs.commonModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
        return false
      }
    },
    signalSendMail: async function () {
      try {
        if (!this.isOperationPossible) {
          const isValid = await this.v$.$validate()

          if (!isValid) return false
          // 空白文字のみの入力の可能性がある為、メールアドレスの空白文字を削除する
          this.mailAddress = this.mailAddress.trim()
          this.brideMailAddress = this.brideMailAddress.trim()

          this.mailAddressInMsg = this.mailAddress
          this.brideMailAddressInMsg = this.brideMailAddress
          this.$refs.commonModal.msgBoxOk('メールを送信しました')
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$refs.commonModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    changeIsOperationPossible (value) {
      this.isOperationPossible = value
    }
  },
  mounted () {
    try {
      this.isOperationPossible = false
      cstore.commit('setIsOperationPossible', this.isOperationPossible)
    } catch (err) {
      CommonLogModel.apiSetStore(this.$refs.commonModal, {'timestampMs': Date.now(), 'error': err}, () => {
      })
    }
  },
  created: function () {
    try {
      this.shinroShinpu1 = cstore.getters.shinroShinpu1
      this.shinroShinpu2 = cstore.getters.shinroShinpu2
      if (cstore.getters.mailAddress) {
        this.mailAddressInMsg = cstore.getters.mailAddress.trim()
        this.mailAddress = cstore.getters.mailAddress.trim()
      }
      if (cstore.getters.brideMailAddress) {
        this.brideMailAddressInMsg = cstore.getters.brideMailAddress.trim()
        this.brideMailAddress = cstore.getters.brideMailAddress.trim()
      }
      if (cstore.getters.shinroShinpu1 === 'shinpu' && cstore.getters.shinroShinpu2 === 'shinro') {
        [this.mailAddressInMsg, this.brideMailAddressInMsg, this.mailAddress, this.brideMailAddress] = [this.brideMailAddressInMsg, this.mailAddressInMsg, this.brideMailAddress, this.mailAddress]
        this.shinroShinpu1 = 'shinro'
        this.shinroShinpu2 = 'shinpu'
      }
    } catch (err) {
      CommonLogModel.apiSetStore(this.$refs.commonModal, {'timestampMs': Date.now(), 'error': err}, () => {
      })
    }
  },
  unmounted () {
    try {
      if (CustomerUpdateModel.getStore()) {
        CustomerUpdateModel.removeStore()
      }
    } catch (err) {
      CommonLogModel.apiSetStore(this.$refs.commonModal, {'timestampMs': Date.now(), 'error': err}, () => {
      })
    }
  }
}
</script>
<style scoped type="text/css">
  .white-btn-disabled:disabled {
    color: rgb(0, 123, 255);
    border-color: rgb(0, 123, 255);
    background-color: #fff;
    opacity: 1;
  }
  .form-control:disabled {
    background-color: #fff;
  }
  input[type=radio] {
    transform: scale(2);
  }
</style>
